import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Box } from '../Box/index.js';
import { useInputGroupContext } from '../InputGroup/index.js';

const StyledBaseInput = styled(Box).withConfig({
  displayName: "Input__StyledBaseInput",
  componentId: "sc-1lqa10a-0"
})(["&::-webkit-outer-spin-button,&::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}&[type='number']{-moz-appearance:textfield;}&:placeholder-shown{text-overflow:ellipsis;}&:disabled{background-color:", ";border-color:", ";cursor:not-allowed;color:", ";&:hover{border-color:", ";}::placeholder{opacity:1;color:", ";}}&:focus{box-shadow:", ";border-color:", ";outline:0;&:hover{border-color:", ";}}&:hover{border-color:", ";}", ""], themeGet('colors.white'), themeGet('colors.inputDisabled'), themeGet('colors.inputDisabled'), themeGet('colors.inputDisabled'), themeGet('colors.inputDisabled'), themeGet('shadows.focus'), themeGet('colors.inputActiveFocus'), themeGet('colors.inputActive'), themeGet('colors.inputHover'), _ref => {
  let {
    isInvalid
  } = _ref;
  return isInvalid && css(["border-color:", ";&:focus{box-shadow:", ";border-color:", ";&:hover{border-color:", ";}}&:hover{border-color:", ";}"], themeGet('colors.inputAlert'), themeGet('shadows.error'), themeGet('colors.inputAlert'), themeGet('colors.inputAlert'), themeGet('colors.inputAlert'));
});
const Input = /*#__PURE__*/forwardRef((_ref2, forwardedRef) => {
  let {
    children,
    type = 'text',
    isDisabled,
    isInvalid,
    isRequired,
    isReadOnly,
    ...rest
  } = _ref2;
  const formControl = useInputGroupContext();
  const _isDisabled = isDisabled || formControl.isDisabled;
  const _isInvalid = isInvalid || formControl.isInvalid;
  const _isRequired = isRequired || formControl.isRequired;
  const _isReadOnly = isReadOnly || formControl.isReadOnly;
  return /*#__PURE__*/React__default.createElement(StyledBaseInput, _extends({
    ref: forwardedRef,
    _placeholder: {
      color: 'inputPlaceholder'
    },
    appearance: "none",
    "aria-disabled": _isDisabled,
    "aria-invalid": _isInvalid,
    "aria-readonly": _isReadOnly,
    "aria-required": _isRequired,
    as: "input",
    border: "1px solid",
    borderColor: "inputDefault",
    borderRadius: "radiusDefault",
    color: "textPrimary",
    disabled: _isDisabled,
    fontFamily: "normal",
    fontSize: {
      base: 'fontSize30',
      md: 'fontSize20'
    },
    height: "40px",
    id: formControl.groupId,
    isInvalid: _isInvalid,
    outline: "none" // Needed so it doesn't conflict with InputElemGroup Icons
    ,
    padding: "9px 16px",
    required: _isRequired,
    transition: "fast",
    transitionProperty: "box-shadow",
    type: type,
    verticalAlign: "middle",
    width: "100%"
  }, rest), children);
});

export { Input, StyledBaseInput };
